import { twMerge } from "tailwind-merge"

const ShadowBoxWrapper = ({className, children, ...rest}) => {
  
  const mergedClass = twMerge("bg-white rounded-xl p-4 shadow-sm shadow-gray-200/50 ring-1 ring-black/[0.04]", className)

  return (
    <div className={mergedClass} {...rest} >
      {children}
    </div>
  )
}

export default ShadowBoxWrapper